import bbbProductTerms from '../../api/bbbProductTerms';
import * as types from '../mutation-types';

const state = {
  bbb_product_terms: []
};

const getters = {
  BBBProductTerms: state => state.bbb_product_terms
};

const actions = {
  getBBBProductTerms({ commit }) {
    bbbProductTerms.getBBBProductTerms().then(response => {
      commit(types.SET_BBB_PRODUCT_TERMS, response);
    });
  }
};

const mutations = {
  [types.SET_BBB_PRODUCT_TERMS](state, response) {
    state.bbb_product_terms = response.data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
